import {useEffect, useState} from 'react'
import Modal from '../Modal'
import {CampaignTranslation} from '../../redux/campaignTypes'
import InputField from '../InputField'
import useCampaignActions from "../../hooks/useCampaignActions";

interface Props {
  campaignId: string
  initialValue: CampaignTranslation
  visible: boolean
  onCloseClick: () => void
}

const UpdateCampaignTranslationModal = ({campaignId, initialValue, visible, onCloseClick}: Props) => {
  const [translation, setTranslation] = useState<CampaignTranslation>(initialValue)

  const {setCampaignTranslation} = useCampaignActions()

  useEffect(() => {
    setTranslation({
      language: initialValue.language,
      title: initialValue.title,
      summary: initialValue.summary
    })
  }, [initialValue])

  const handleOnOk = () => {
    setCampaignTranslation(campaignId, translation)
    onCloseClick && onCloseClick()
  }

  const handleOnCancel = () => {
    onCloseClick && onCloseClick()
  }

  const handleOnChange = (propName: string, value: any) => {
    if (translation) {
      setTranslation({...translation, [propName]: value})
    }
  }

  return (
    <Modal
      title='Edit translation'
      show={visible}
      okButtonTitle='Save'
      cancelButtonTitle='Cancel'
      onHide={() => handleOnCancel()}
      onOkClick={() => handleOnOk()}
      onCancelClick={() => handleOnCancel()}
    >
      <h5>Language: {translation?.language ?? '-'}</h5>
      <InputField
        id='title'
        value={translation?.title ?? ''}
        onChange={(event) => handleOnChange('title', event.target.value)}
        label='Title'
        placeholder=''
      />
      <InputField
        id='summary'
        value={translation?.summary ?? ''}
        onChange={(event) => handleOnChange('summary', event.target.value)}
        label='Summary'
        placeholder=''
      />
    </Modal>
  )
}

export default UpdateCampaignTranslationModal
